<template>

        <v-dialog persistent transition="scale-transition" max-width="376" v-model="value">

            <toolbar-page title="Two factor authentication"></toolbar-page>

            <v-card>
                <v-card-text class="text-md-center pt-4">
                    <v-icon dark x-large>mdi-fingerprint</v-icon>
                    Fingerprinting...
                </v-card-text>
            </v-card>

        </v-dialog>

</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';
import AnimatedBackground from "../../../components/UI/AnimatedBackground";

export default {

    components: {
        AnimatedBackground,
        ToolbarPage
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {}
    },

    computed: {},

    created() {

    },

    mounted() {

    },

    methods: {}
}
</script>
